import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    token: '',
    permission: '',
    team: '',
  },
  getters: {
    isLoggedIn(state): boolean {
      return !!state.token
    },
    getPermission(state): string {
      return state.permission
    },
    getTeam(state): string {
      return state.team
    }
  },
  mutations: {
    setToken(state, token){
      state.token = token
    },
    clearToken(state){
      state.token = '';
    },
    setPermission(state, permission){
      state.permission = permission;
    },
    clearPermission(state){
      state.permission = '';
    },
    setTeam(state, team){
      state.team = team;
    },
    clearTeam(state){
      state.team = '';
    },
  },
  actions: {
    setToken({ commit }, token){
      commit('setToken', token);
    },
    clearToken({ commit }){
      commit('clearToken');
    },
    setPermission({ commit }, permission){
      commit('setPermission', permission);
    },
    clearPermission({ commit }){
      commit('clearPermission');
    },
    setTeam({ commit }, team){
      commit('setTeam', team);
    },
    clearTeam({ commit }){
      commit('clearTeam');
    }
  },
  modules: {
  },
  plugins: [createPersistedState()],
})
